/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportRequestDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportRequestDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportResponseDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportTemplateParseDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardSampleFileBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AwardImportService {

    /**
     * @returns Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardImportDownloadImportSample(): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-import/download-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardImportAwardImport(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-import/award-import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardImportValidatePermission(
requestBody?: Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportRequestDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-import/validate-permission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param currentUsers 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardImportValidatePermissionInBackground(
currentUsers?: string,
requestBody?: Array<Wealthlane_AwardService_Dtos_BulkImport_AwardImportDto_AwardImportTemplateParseDto>,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-import/validate-permission-in-background',
            query: {
                'CurrentUsers': currentUsers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
